// biome-ignore lint/style/useImportType: wrong warning
import React from 'react';
import { buildRegularSource, buildWebpSource, priorityProp } from './utils.js';
export function SRCImage({ pictureClassName, pictureStyle, imgClassName, imgStyle, data, usePlaceholder = true, priority = false, sizes, srcSetCandidates = [0.25, 0.5, 0.75, 1, 1.5, 2, 3, 4], referrerPolicy = 'no-referrer-when-downgrade', }) {
    var _a, _b, _c, _d;
    const webpSource = buildWebpSource(data, sizes);
    const regularSource = buildRegularSource(data, sizes, srcSetCandidates);
    const placeholderStyle = usePlaceholder && data.base64
        ? {
            backgroundImage: `url("${data.base64}")`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 50%',
            color: 'transparent',
        }
        : usePlaceholder && data.bgColor
            ? { backgroundColor: (_a = data.bgColor) !== null && _a !== void 0 ? _a : undefined, color: 'transparent' }
            : undefined;
    const { width } = data;
    const height = (_b = data.height) !== null && _b !== void 0 ? _b : Math.round(data.aspectRatio ? width / data.aspectRatio : 0);
    const sizingStyle = {
        aspectRatio: `${width} / ${height}`,
        width: '100%',
        maxWidth: `${width}px`,
        height: 'auto',
    };
    const loadingBehaviourProps = priority
        ? priorityProp(priority ? 'high' : undefined)
        : { loading: 'lazy' };
    return (React.createElement("picture", { className: pictureClassName, style: pictureStyle },
        webpSource,
        regularSource,
        data.src && (
        // biome-ignore lint/a11y/useAltText: We do with alt the best we can
        React.createElement("img", Object.assign({ src: data.src, alt: (_c = data.alt) !== null && _c !== void 0 ? _c : '', title: (_d = data.title) !== null && _d !== void 0 ? _d : undefined }, loadingBehaviourProps, { className: imgClassName, style: Object.assign(Object.assign(Object.assign({}, placeholderStyle), sizingStyle), imgStyle), referrerPolicy: referrerPolicy })))));
}
//# sourceMappingURL=index.js.map